// frontend/src/pages/PaychequeDetail/components/AdjustmentBanner.tsx
// Amber "Adjustment cheque" banner shown when a paycheque corrects a previous one.
// Parent decides when to render (based on pc.is_adjustment).

import React from "react";
import { AlertTriangle } from "lucide-react";

interface AdjustmentBannerProps {
  /** Human-readable reason for the adjustment. Optional. */
  reason?: string;
}

export default function AdjustmentBanner({
  reason,
}: AdjustmentBannerProps): React.ReactElement {
  return (
    <div
      className="no-print"
      style={{
        background: "#FEF3C7",
        border: "1px solid #FDE68A",
        borderRadius: 8,
        padding: "12px 14px",
        marginBottom: 18,
        display: "flex",
        alignItems: "flex-start",
        gap: 10,
      }}
    >
      <div
        style={{
          width: 32,
          height: 32,
          borderRadius: 8,
          background: "#FDE68A",
          color: "#92400E",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          marginTop: 2,
        }}
      >
        <AlertTriangle size={16} strokeWidth={2.5} />
      </div>
      <div style={{ flex: 1 }}>
        <div
          style={{
            fontSize: 11,
            color: "#92400E",
            letterSpacing: "0.5px",
            textTransform: "uppercase",
            fontWeight: 700,
            marginBottom: 3,
          }}
        >
          Adjustment cheque
        </div>
        <div style={{ fontSize: 13, color: "#1A2332", fontWeight: 600, marginBottom: 4 }}>
          This pay stub was created to correct a previous pay stub.
        </div>
        {reason && (
          <div style={{ fontSize: 12.5, color: "#1A2332", fontWeight: 500 }}>
            <span style={{ fontWeight: 700 }}>Reason:</span> {reason}
          </div>
        )}
      </div>
    </div>
  );
}